import ResourcesDispatcher from "../config/ResourcesDispatcher";
export default class TopSideGridAnimations {
    constructor(animationConfigs, scene) {
        this.WALK_MOVEMENT_DISTANCE = 150;
        this.WALK_ANIMATION_DURATION = 2000;
        this.WALK_BOB_HEIGHT = 15;
        this.WALK_BOB_FREQUENCY = 5;
        this.OFF_SCREEN_Y = -1500;
        this.OFF_SCREEN_X_SX = -500;
        this.OFF_SCREEN_X_DX = 1500;
        this.DELAY = 200;
        this.FLY_DURATION = 3000;
        this.isAnimating = false;
        this.scene = scene;
        this.topSideGridAnimation = this.scene.add.spine(animationConfigs.x, animationConfigs.y, ResourcesDispatcher.SPINES.Top_Side_Grid_Animation.jsonKey, ResourcesDispatcher.SPINES.Top_Side_Grid_Animation.atlasKey)
            .setOrigin(animationConfigs.origin)
            .setScale(animationConfigs.scale)
            .setVisible(false);
        this.minX = animationConfigs.minX;
        this.maxX = animationConfigs.maxX;
        this.startY = animationConfigs.startY;
        this.minY = animationConfigs.minY;
        this.maxY = animationConfigs.maxY;
        this.gameLogicVariableManager = window.GameLogicVariableManager;
    }
    // mostra o nasconde
    show(isOn) {
        this.topSideGridAnimation.setVisible(isOn);
        this.idleTimer();
    }
    // animazione iniziale
    start(isOn) {
        return new Promise(async (resolve) => {
            const randomX = Phaser.Math.Between(this.minX, this.maxX);
            this.topSideGridAnimation.setPosition(randomX, this.startY);
            this.topSideGridAnimation.setVisible(isOn);
            // // Anima la traslazione su 500ms (adatta a piacere)
            this.scene.tweens.add({
                targets: this.topSideGridAnimation,
                y: { from: this.OFF_SCREEN_Y, to: this.startY },
                duration: this.FLY_DURATION,
                ease: 'Cubic.easeOut',
                onStart: () => {
                    this.topSideGridAnimation.animationState.setAnimation(0, "appoggio_enter", false);
                },
                onComplete: () => {
                    this.idle();
                    this.idleTimer();
                    resolve(true);
                }
            });
        });
    }
    // idle
    idle() {
        this.topSideGridAnimation.animationState.addAnimation(0, "idle", true);
    }
    // gestione camminata a destra o sinistra
    playWalk() {
        if (this.isAnimating)
            return;
        this.isAnimating = true;
        const intervalSize = this.maxX - this.minX;
        const quarterSize = intervalSize / 4;
        const relativePos = this.topSideGridAnimation.x - this.minX;
        // Primo quarto: walkSx
        if (relativePos < quarterSize) {
            this.walkDx();
        }
        // Secondo e terzo quarto: arbitrariamente walkDx o walkSx
        else if (relativePos < quarterSize * 3) {
            Math.random() < 0.5 ? this.walkDx() : this.walkSx();
        }
        // Quarto quarto: walkDx
        else {
            this.walkSx();
        }
    }
    // camminata sinistra
    walkSx() {
        return new Promise(async (resolve) => {
            const currentX = this.topSideGridAnimation.x;
            const currentY = this.topSideGridAnimation.y;
            const newX = currentX - this.WALK_MOVEMENT_DISTANCE;
            // ⭐ Avvia animazione sprite
            this.topSideGridAnimation.animationState.setAnimation(0, "camminata_sx", false);
            // ⭐ Movimento laterale
            this.scene.tweens.add({
                targets: this.topSideGridAnimation,
                x: newX,
                duration: this.WALK_ANIMATION_DURATION,
                ease: 'Linear'
            });
            // ⭐ Effetto bobbing verticale CONTEMPORANEAMENTE
            // Calcola la durata di un singolo bob
            const bobDuration = this.WALK_ANIMATION_DURATION / (this.WALK_BOB_FREQUENCY * 2);
            this.scene.tweens.add({
                targets: this.topSideGridAnimation,
                y: {
                    from: currentY,
                    to: currentY - this.WALK_BOB_HEIGHT
                },
                duration: bobDuration,
                ease: 'Sine.easeInOut',
                yoyo: true,
                repeat: this.WALK_BOB_FREQUENCY - 1,
                onComplete: () => {
                    this.isAnimating = false;
                    this.idle();
                    resolve(true);
                }
            });
        });
    }
    // camminata destra
    walkDx() {
        return new Promise(async (resolve) => {
            const currentX = this.topSideGridAnimation.x;
            const currentY = this.topSideGridAnimation.y;
            const newX = currentX + this.WALK_MOVEMENT_DISTANCE;
            // ⭐ Avvia animazione sprite
            this.topSideGridAnimation.animationState.setAnimation(0, "camminata_dx", false);
            // ⭐ Movimento laterale
            this.scene.tweens.add({
                targets: this.topSideGridAnimation,
                x: newX,
                duration: this.WALK_ANIMATION_DURATION,
                ease: 'Linear'
            });
            // ⭐ Effetto bobbing verticale CONTEMPORANEAMENTE
            const bobDuration = this.WALK_ANIMATION_DURATION / (this.WALK_BOB_FREQUENCY * 2);
            this.scene.tweens.add({
                targets: this.topSideGridAnimation,
                y: {
                    from: currentY,
                    to: currentY - this.WALK_BOB_HEIGHT
                },
                duration: bobDuration,
                ease: 'Sine.easeInOut',
                yoyo: true,
                repeat: this.WALK_BOB_FREQUENCY - 1,
                onComplete: () => {
                    this.isAnimating = false;
                    this.idle();
                    resolve(true);
                }
            });
        });
    }
    // uscita
    exit() {
        return new Promise(async (resolve) => {
            this.topSideGridAnimation.animationState.setAnimation(0, "appoggio_exit", false);
            this.scene.tweens.add({
                targets: this.topSideGridAnimation,
                y: { from: this.topSideGridAnimation.y, to: this.OFF_SCREEN_Y },
                duration: this.FLY_DURATION,
                delay: this.DELAY,
                ease: 'Cubic.easeOut',
                onComplete: () => {
                    this.idleReset();
                    resolve(true);
                }
            });
        });
    }
    // gestione volo destra o sinistra
    playFly() {
        if (this.isAnimating)
            return;
        this.isAnimating = true;
        const randomY = Phaser.Math.Between(this.minY, this.maxY);
        Math.random() < 0.5 ? this.flyDx(randomY) : this.flySx(randomY);
    }
    // volo destra
    flyDx(y) {
        return new Promise(async (resolve) => {
            this.topSideGridAnimation.animationState.setAnimation(0, "volo_enter_dx", true);
            const initialY = this.topSideGridAnimation.y;
            this.topSideGridAnimation.y = y;
            this.scene.tweens.add({
                targets: this.topSideGridAnimation,
                x: { from: this.OFF_SCREEN_X_DX, to: this.OFF_SCREEN_X_SX },
                duration: this.FLY_DURATION,
                ease: 'Cubic.easeOut',
                onComplete: () => {
                    this.isAnimating = false;
                    this.topSideGridAnimation.y = initialY;
                    resolve(true);
                }
            });
        });
    }
    // volo sinistra
    flySx(y) {
        return new Promise(async (resolve) => {
            this.topSideGridAnimation.animationState.setAnimation(0, "volo_enter_sx", true);
            const initialY = this.topSideGridAnimation.y;
            this.topSideGridAnimation.y = y;
            this.scene.tweens.add({
                targets: this.topSideGridAnimation,
                x: { from: this.OFF_SCREEN_X_SX, to: this.OFF_SCREEN_X_DX },
                duration: this.FLY_DURATION,
                ease: 'Cubic.easeOut',
                onComplete: () => {
                    this.isAnimating = false;
                    this.topSideGridAnimation.y = initialY;
                    resolve(true);
                }
            });
        });
    }
    // gestione timer idle
    idleTimer() {
        // evita timer multipli
        this.idleReset();
        const min = 2000;
        const max = 8000;
        const loop = () => {
            const delayMs = Phaser.Math.Between(min, max);
            this.delayedAnim = this.scene.time.delayedCall(delayMs, () => {
                if (this.isAnimating)
                    return;
                if (this.gameLogicVariableManager.getCurrentGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.BASEGAME) {
                    this.playWalk();
                }
                else if ((this.gameLogicVariableManager.getCurrentGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.LINKSPIN
                    && this.gameLogicVariableManager.getFutureGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.LINKSPIN) ||
                    (this.gameLogicVariableManager.getCurrentGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.FREEGAME
                        && this.gameLogicVariableManager.getFutureGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.FREEGAME)) {
                    this.playFly();
                }
                loop();
            });
        };
        loop();
    }
    // reset della gestione del timer idle
    idleReset() {
        if (this.delayedAnim && !this.delayedAnim.hasDispatched) {
            this.delayedAnim.remove(false);
        }
        this.delayedAnim = undefined;
    }
    // ritorna l'istanza
    getTopSideGridAnimation() {
        return this.topSideGridAnimation;
    }
    // vincita
    win() {
        // disattiva eventuali timer di idle per evitare sovrapposizioni
        this.idleReset();
        // TODO: DA CAMBIARE CON LA VINCITA
        this.topSideGridAnimation.animationState.setAnimation(0, "spavento", false);
        this.idle();
        this.idleTimer();
    }
    // animazione jumpscare
    jumpscare() {
        this.idleReset();
        setTimeout(() => {
            this.topSideGridAnimation.animationState.setAnimation(0, "spavento", false);
            this.idle();
            this.idleTimer();
        }, 1200);
    }
    // effetto giorno
    day() {
        this.topSideGridAnimation.skeleton.color.set(1, 1, 1, 1);
    }
    // effetto notte
    night() {
        this.topSideGridAnimation.skeleton.color.set(0.3, 0.8, 0.95, 1);
    }
    // transizione tra due colori per spine
    transitionColor(currentColor, targetColor, duration = 500) {
        this.scene.tweens.add({
            targets: currentColor,
            r: targetColor.r,
            g: targetColor.g,
            b: targetColor.b,
            a: targetColor.a,
            duration,
            ease: 'Sine.easeInOut',
            onUpdate: () => {
                this.topSideGridAnimation.skeleton.color.set(currentColor.r, currentColor.g, currentColor.b, currentColor.a);
            }
        });
    }
}
